import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { passingsToExport } from 'api/passings/getFilteredPassings';
import { DownloadButton } from 'components/Button';
import { PASSINGS_BY_TRANSACTION_DOWNLOAD_URL, invoicePassingsDownloadUrl } from 'constants/urls';
import downloadBlob from 'utils/download/downloadBlob';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from './InvoicePassingsStyles';
import { useRecoilValue } from 'recoil';
export default function InvoicePassingsDownload({
  invoiceId,
  invoiceNumber,
  agreementName,
  dates,
  disabled,
  obeNumber,
  registrationNumber,
  max,
  accountId,
  showCheckbox
}) {
  const {
    t,
    i18n
  } = useTranslation();
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
  const {
    downloadButtons,
    column
  } = useStyles();
  const passingsToExportLst = useRecoilValue(passingsToExport);
  const disableButtons = disabled || isDownloadingCsv || isDownloadingPdf || showCheckbox && passingsToExportLst.length === 0 || !max;
  const handleDownloadClick = async format => {
    const url = invoicePassingsDownloadUrl(invoiceId);
    const filename = `${t('titles.invoice')}_${invoiceNumber}_${agreementName}.${format}`;
    const data = {
      ...dates,
      offset: 0,
      max,
      obeNumber,
      language: isNorwegian(i18n) ? 'No' : 'Eng',
      regNumber: registrationNumber,
      format
    };
    await downloadBlob(url, filename, 'POST', data);
  };
  const handleDownloadByTransactionClick = async format => {
    const url = PASSINGS_BY_TRANSACTION_DOWNLOAD_URL;
    const filename = `${t('passings.passings')}.${format}`;
    const data = {
      offset: 0,
      language: isNorwegian(i18n) ? 'No' : 'Eng',
      format,
      transactionIds: passingsToExportLst,
      max: 10,
      accountId
    };
    await downloadBlob(url, filename, 'POST', data);
  };
  const handleDownloadPdfClick = async () => {
    setIsDownloadingPdf(true);
    try {
      if (passingsToExportLst.length > 0) {
        handleDownloadByTransactionClick('pdf');
      } else {
        await handleDownloadClick('pdf');
      }
    } finally {
      setIsDownloadingPdf(false);
    }
  };
  const handleDownloadCsvClick = async () => {
    setIsDownloadingCsv(true);
    try {
      if (passingsToExportLst.length > 0) {
        handleDownloadByTransactionClick('csv');
      } else {
        await handleDownloadClick('csv');
      }
    } finally {
      setIsDownloadingCsv(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: downloadButtons
  }, /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    disabled: disableButtons,
    loading: isDownloadingCsv,
    onClick: handleDownloadCsvClick
  }, `${t('buttons.export_passings_list')} (CSV)`)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    disabled: disableButtons,
    loading: isDownloadingPdf,
    onClick: handleDownloadPdfClick
  }, `${t('buttons.export_passings_list')} (PDF)`)));
}
InvoicePassingsDownload.defaultProps = {
  obeNumber: '',
  registrationNumber: '',
  showCheckbox: true
};